import React from 'react';
import { IconButton } from 'react-native-paper';
import { goBack } from '../../utils/navigation';

const GoBackButton = (props) => (
  <IconButton
    icon="arrow-left"
    onPress={goBack}
    {...props}
  />
);

export default GoBackButton;
